import { Button } from 'avo-ui'
import { ScanBarcodeModal } from 'components/order/manifest/ScanBarcodeModal'
import { PrintManifestModal } from 'components/order/manifest/PrintManifestModal'
import { AddAWBModal } from 'components/order/manifest/AddAWBModal'

export const RightButton = ({
    selectedValue,
    onClickRightButton,
    totalResult,
    modal,
    onHideScanBarcode,
    orderCode,
    setOrderCode,
    isLoadingBulkManifest,
    isLoadingBulkPrintManifest,
    isLoadingAddManualAWB,
    isSelectSameService,
    rightButtonConfirm,
    setModalHandler,
    orderItem,
    onChangeAWB,
}) => {
    return (
        <>
            {selectedValue?.tab === 'pengemasan' && (
                <div className={'flex flex-row gap-x-4'}>
                    <Button
                        title={'Pindah ke Surat Jalan'}
                        disabled={selectedValue?.selectedIds?.length === 0}
                        onClick={() => onClickRightButton('Are You Sure to Move Order to Manifest ?')}
                    />
                    <Button
                        title={'Scan barcode'}
                        disabled={!totalResult}
                        onClick={() => onClickRightButton('move-to-manifest', { scan: true })}
                    />
                    {modal?.scan && (
                        <ScanBarcodeModal
                            show={modal?.scan}
                            onHide={onHideScanBarcode}
                            onChangeHandler={(value) => setOrderCode(value)}
                            orderId={orderCode}
                            isLoading={isLoadingBulkManifest}
                        />
                    )}
                </div>
            )}
            {selectedValue?.tab === 'print surat jalan' && (
                <>
                    <Button
                        title={'Print Surat Jalan'}
                        disabled={!isSelectSameService()}
                        onClick={() => setModalHandler({ printManifest: true })}
                    />
                    {modal?.printManifest && (
                        <PrintManifestModal
                            show={modal?.printManifest}
                            onHide={() => setModalHandler({ printManifest: false })}
                            list={selectedValue?.selectedIds}
                            isLoading={isLoadingBulkPrintManifest}
                            printManifestHandler={rightButtonConfirm}
                        />
                    )}
                </>
            )}
            {selectedValue?.tab === 'tanpa resi' && modal?.addAWB && (
                <AddAWBModal
                    show={modal?.addAWB}
                    onHide={() => setModalHandler({ addAWB: false })}
                    item={orderItem}
                    isLoading={isLoadingAddManualAWB}
                    onChangeHandler={onChangeAWB}
                    onSubmit={rightButtonConfirm}
                />
            )}
        </>
    )
}
